// Printable QR labels for bait stations and devices. The code reads
// "XPDEV:<device id>", which the tech app's scanner matches exactly; the label
// number printed beside it lets a tech type it in if a code is damaged.
// Laid out for standard 1" x 2-5/8" address labels, 30 per sheet.
import { qrDataUrl } from './qr';
import { DEVICE_QR_PREFIX } from '../components/tech/StationScanner';

const esc = (v) => String(v ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

export async function printDeviceLabels(devices, customerName) {
  const win = window.open('', '_blank');
  if (!win) return false;
  const labels = await Promise.all(devices.map(async (d) => ({ d, qr: await qrDataUrl(`${DEVICE_QR_PREFIX}${d.id}`, 220) })));
  win.document.write(`<!doctype html><html><head><meta charset="utf-8"><title>Device labels</title>
<style>
  @page { size: letter; margin: 0.5in 0.19in; }
  body { margin: 0; font-family: Helvetica, Arial, sans-serif; }
  .sheet { display: grid; grid-template-columns: repeat(3, 2.625in); grid-auto-rows: 1in; column-gap: 0.125in; }
  .label { display: flex; align-items: center; gap: 0.08in; padding: 0.06in 0.1in; overflow: hidden; break-inside: avoid; }
  .label img { width: 0.85in; height: 0.85in; }
  .num { font-size: 15pt; font-weight: 700; }
  .meta { font-size: 7pt; color: #333; line-height: 1.2; }
</style></head><body><div class="sheet">
${labels.map(({ d, qr }) => `<div class="label"><img src="${qr}" alt=""/><div>
  <div class="num">${esc(d.label)}</div>
  <div class="meta">${esc(d.type || '')}</div>
  <div class="meta">${esc(customerName || d.customerName || '')}</div>
  <div class="meta">${esc(d.location || '')}</div></div></div>`).join('')}
</div><script>window.onload = () => setTimeout(() => window.print(), 300);</script></body></html>`);
  win.document.close();
  return true;
}
